module.exports = __webpack_public_path__ + "img/916-9c81e4.png";